import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { UnsubscribeOnDestroyAdapter } from '../../_shared';
import { AuthService } from '../../_infrastructure/services/auth/user-auth/auth.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.css'],
  standalone: false
})
export class MainLayoutComponent extends UnsubscribeOnDestroyAdapter implements OnInit {

  //Função para ocultar o vlivras na área adm, pois o vlibras precisa ser global para ser exibido
  constructor(private router: Router,
    private readonly authService: AuthService,
  ) {
    super();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const vw = document.querySelector('[vw]') as HTMLElement;
        if (!vw) return;

        if (event.url.startsWith('/adm')) {
          vw.style.display = 'none';
        } else {
          vw.style.display = 'block';
        }
      }
    });
  }

  ngOnInit(): void {
    this.subs.sink = this.authService.currentUser.subscribe(user => {
      const tema = user?.temaConfiguracao;
      //Descomentar o trexo abaixo quando finalizar a configuração dos temas
      // if (tema) {
      //   document.documentElement.setAttribute('data-theme', tema);
      //   return;
      // }

      // document.documentElement.removeAttribute('data-theme');
    });
  }

}